import React from 'react';
import PropTypes from 'prop-types';
import { StyledButtons } from './style';

const Button = ({
  children,
  className,
  onClick,
  primary,
  secondary,
  dark,
  green,
  modal,
  ghost,
  small,
  type,
  name,
  fixed,
  isFloat,
  transparent,
  id,
  disabled
}) => (
  <StyledButtons
    primary={primary}
    secondary={secondary}
    ghost={ghost}
    dark={dark}
    green={green}
    small={small}
    fixed={fixed}
    transparent={transparent}
    modal={modal}
    className={className}
    onClick={onClick}
    id={id}
    isFloat={isFloat}
    name={name}
    type={type}
    disabled={disabled}
  >
    {children}
  </StyledButtons>
);

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.string,
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  modal: PropTypes.bool,
  id: PropTypes.string,
  ghost: PropTypes.bool,
  dark: PropTypes.bool,
  green: PropTypes.bool,
  small: PropTypes.bool,
  fixed: PropTypes.bool,
  transparent: PropTypes.bool,
  name: PropTypes.string,
  disabled: PropTypes.bool
};

Button.defaultProps = {
  primary: true,
  ghost: false,
  transparent: false
};

export default Button;
